<div class="block">
  <h1>Systeminställningar</h1>

  <woo-tabs default="system">
    @if(isAdmin) {
      <woo-tab name="system" label="System">
          <system-settings-form></system-settings-form>
      </woo-tab>
      <woo-tab name="publisher-groups" label='Publicistgrupper'>
          <publisher-group-settings></publisher-group-settings>
      </woo-tab>
      <woo-tab name="system-messages" label="Systemmeddelanden">
          <system-messages></system-messages>
      </woo-tab>
    }
    @if(isAdminOrPlanner) {
      <woo-tab name="mms" label="MMS">
        <mms-admin></mms-admin>
      </woo-tab>
    }
  </woo-tabs>
</div>
